import { render, staticRenderFns } from "./BlogHighlights.vue?vue&type=template&id=3d948eec&"
import script from "./BlogHighlights.vue?vue&type=script&lang=js&"
export * from "./BlogHighlights.vue?vue&type=script&lang=js&"
import style0 from "./BlogHighlights.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports